import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';
import { CompInfo } from '@wix/editor-elements-types';
import {
  SearchBoxProps,
  SearchBoxDefinition,
  SearchBoxCSSVars,
} from '@wix/thunderbolt-components';
import {
  ISearchBoxMapperProps,
  ISearchBoxMapperCSSVars,
} from '../SearchBox.types';

const getDirection = (
  direction: CompInfo['direction'],
  experiments: CompInfo['experiments'],
) => {
  return experiments['specs.thunderbolt.SearchBoxRtl'] === true
    ? direction
    : 'ltr';
};

export const props = withCompInfo<
  ISearchBoxMapperProps,
  SearchBoxDefinition,
  SearchBoxProps
>()(['direction', 'experiments'], ({ direction, experiments }, carmiProps) => {
  return {
    ...carmiProps,
    direction: getDirection(direction, experiments),
  };
});

export const css = withCompInfo<
  ISearchBoxMapperCSSVars,
  SearchBoxDefinition,
  SearchBoxCSSVars
>()(
  ['compProps', 'direction', 'experiments', 'isMobileView'],
  ({ compProps, direction, experiments, isMobileView }, carmiCss) => {
    const { textAlignment } = compProps;
    const isCenterTextAlignment = textAlignment === 'center';
    const dir = getDirection(direction, experiments);
    const textPaddingEnd = isCenterTextAlignment && isMobileView ? '4px' : '0';
    const textPadding =
      dir === 'rtl'
        ? `8px 0 8px ${textPaddingEnd}`
        : `8px ${textPaddingEnd} 8px 0`;

    return {
      ...carmiCss,
      '--input-text-align': isCenterTextAlignment ? textAlignment : undefined,
      '--text-padding': textPadding,
    };
  },
);

export default createComponentMapperModel({ props, css });
